import axiosInstance from '../axios/axiosInstance';

export const getAllWatchList = () =>
	axiosInstance.get(
		`http://eaapi2.dev.arabiansystems.com/v2/account/watchlist`
	);
